export default __webpack_public_path__ + "assets/images/9830f9d1b6ce33a8f9156c925c368441.png";